<template>
  <v-card v-bind="$attrs" max-width="350px" class="rounded-lg mt-10 mx-auto" elevation="2" shaped
    align="center">
    <v-flex v-if="icon" fill-height row justify-center align-center>
      <v-btn :color="color" :max-height="icon ? 90 : undefined" class="disable-pointer" dark
        elevation="2" fab x-large absolute>
        <v-icon class="white--text" x-large if="icon" size="36" v-text="icon" />
      </v-btn>
    </v-flex>
    <v-list class="rounded-lg">

      <v-list-item class="mt-14">
        <v-list-item-content class="pt-0">
          <v-list-item-title align="center" class="font-weight-normal display-2">
            {{ value }}
          </v-list-item-title>
          <v-list-item-title align="center" class="font-weight-regular title" v-text="title">
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="my-0"></v-divider>
    <v-list class="my-0 py-0">
      <v-list-item>
        <v-icon class="mr-2" size="20" v-if="subIcon" v-text="subIcon" />
        <span class="mr-4 font-weight-regular" v-if="smallValue">{{ smallValue }}</span>
        <span v-text="subtitle" class="body-2 font-weight-regular"></span>
      </v-list-item>
    </v-list>
    <!-- <v-list v-if="goIcon" class="ma-0 pa-0">
      <v-list-item>
        <v-list-item-content>
          <div class="d-flex justify-end">
            <v-icon if="icon" v-text="goIcon" />
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->
  </v-card>
</template>

<script>
export default {
  name: 'DataCard',

  props: {
    subtitle: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: undefined
    },
    subIcon: {
      type: String,
      default: undefined
    },
    goIcon: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Number,
        String],
      default: undefined
    },
    smallValue: {
      type: [Number,
        String],
      default: undefined
    }
  },

  computed: {}
}
</script>
